import { render, staticRenderFns } from "./LpLink.vue?vue&type=template&id=b8b13e04&scoped=true"
import script from "./LpLink.vue?vue&type=script&lang=js"
export * from "./LpLink.vue?vue&type=script&lang=js"
import style0 from "./LpLink.vue?vue&type=style&index=0&id=b8b13e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b13e04",
  null
  
)

export default component.exports